_ = require 'underscore'
CardLocationMenuPopoverView = require 'app/scripts/views/map/card-location-menu-popover-view'
Controller = require 'app/scripts/controller'
Dialog = require 'app/scripts/views/lib/dialog'
GoogleMapsApi = require 'app/scripts/lib/google-maps-api'
{ getKey, Key } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_location')
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ Noun, Verb, trackUe } = require '@trello/analytics'
{ formatLatLng } = require 'app/common/lib/util/format-coordinates'

MAX_LOCATION_NAME_LENGTH = 16384

template = t.renderable ({ staticMapImage, address, externalUrl, editable }) ->
  t.div '.card-back-location.js-open-in-map', ->
    t.img '.card-back-static-map', { src: staticMapImage }
    t.div '.card-back-location-footer', ->
      t.div '.card-back-location-details', ->
        inputClasses =
          'mod-card-back-location-name': true
          'js-card-location-name-input': true
        t.textarea { class: t.classify(inputClasses), disabled: !editable, dir: 'auto' }
        if address
          t.div '.quiet', ->
            t.text address
      t.div '.card-back-location-controls', ->
        t.a '.card-back-location-controls-option.js-track-external-link', { href: externalUrl, target: '_blank', rel: 'noopener noreferrer' }, ->
          t.icon 'external-link', { class: 'icon-sm' }
        if editable
          t.a '.card-back-location-controls-option.js-open-menu', ->
            t.icon 'overflow-menu-horizontal', { class: 'icon-sm' }

module.exports = class CardLocationView extends View

  initialize: ->
    @makeDebouncedMethods 'render',
      'renderLocationName'

    @listenTo @model,
      'change:coordinates': @renderDebounced
      'change:locationName': @renderLocationNameDebounced

  events:
    'click .js-open-in-map': 'openInMap'
    'click .js-open-menu': 'openMenu'
    'click .js-track-external-link': 'trackExternalLinkClick'

    'click .js-card-location-name-input': 'locationNameClick'
    'keydown .js-card-location-name-input': 'locationNameKeyDownEvent'
    'focus .js-card-location-name-input': (e) ->
      @startLocationNameEditing({ focus: false })

    'blur .js-card-location-name-input': 'saveLocationNameEditing'

  locationNameKeyDownEvent: (e) ->
    if getKey(e) == Key.Enter
      Util.stop(e) # prevents new lines
      @saveLocationNameEditing()

    if getKey(e) == Key.Escape
      Util.stop(e) # don't close the overlay…
      @cancelLocationNameEditing()

    return

  startLocationNameEditing: (options = {}) ->
    $input = @$('.js-card-location-name-input')

    if !$input.hasClass('is-editing')
      $input.addClass('is-editing')

      if options.focus
        $input.focus().select()

    return

  saveLocationNameEditing: ->
    $input = @$('.js-card-location-name-input')
    if $input.hasClass('is-editing')
      @stopLocationNameEditing()
      @saveLocationName()

  cancelLocationNameEditing: ->
    @stopLocationNameEditing()
    @renderLocationName()

  stopLocationNameEditing: ->
    $input = @$('.js-card-location-name-input')
    if $input.hasClass('is-editing')
      $input.removeClass('is-editing')
      $input.blur()
      removeAllRanges()

    return

  renderLocationName: ->
    $input = @$('.js-card-location-name-input')

    if !$input.hasClass('is-editing')
      name = @model.get('locationName')

      if !name? || !name.length
        { latitude, longitude } = @model.get('coordinates')
        name = formatLatLng(latitude, longitude)

      $input.val(name).trigger('autosize.resize', false)

  locationNameClick: (e) ->
    Util.stopPropagation(e)

  saveLocationName: ->
    $input = @$('.js-card-location-name-input')
    newValue = $input.val()
    locationName = @model.get('locationName')

    # remove whitespace
    newValue = newValue.replace(/\s+/g, ' ').trim()

    # if it's the same name, don't save
    if newValue == locationName
      return

    # if it's too long, don't save
    if newValue.length > MAX_LOCATION_NAME_LENGTH
      return

    # if it's empty then clear the name
    if newValue.length == 0
      newValue = null

    trackUe(Noun.CARD_DETAILS, Verb.EDITS, 'location name', '', '', 'by clicking the location name', {
      idCard: @model.id
      idList: @model.getList().id
      idBoard: @model.getBoard().id
    })

    @model.update 'locationName', newValue

    return

  openMenu: (e) ->
    Util.stopPropagation(e)
    PopOver.toggle
      elem: @$('.js-open-menu')
      view: CardLocationMenuPopoverView
      options: { @model, @modelCache }

  trackExternalLinkClick: (e) ->
    Util.stopPropagation(e)
    trackUe(Noun.CARD_DETAILS, Verb.OPENS, Noun.EXTERNAL_MAP, '', '', 'by clicking the external link button', {
      idCard: @model.id
      idList: @model.getList().id
      idBoard: @model.getBoard().id
    })

  openInMap: (e) ->
    Util.stop(e)

    trackUe(Noun.CARD_DETAILS, Verb.OPENS, Noun.BOARD_MAP, '', '', 'by clicking the map on the card details', {
      idCard: @model.id
      idList: @model.getList().id
      idBoard: @model.getBoard().id
    })

    { latitude, longitude } = @model.get('coordinates')
    center =
      lat: latitude
      lng: longitude

    boardView = Controller.getCurrentBoardView()

    # The map is already open;
    # Make the map zoom into the location.
    if boardView.mapView?
      Dialog.hide()
      boardView.mapView.centerTo(center, 17)
      return

    boardView.navigateToMap(center, @model)

  render: ->
    coordinates = @model.get('coordinates')
    data = {
      staticMapImage: GoogleMapsApi.getStaticMap({
        zoom: 14
        width: 676
        height: 200
        scale: 2
        markers: [coordinates]
      })
      address: @model.get('address')
      locationName: @model.get('locationName')
      externalUrl: GoogleMapsApi.getUrl(coordinates.latitude, coordinates.longitude)
      editable: @model.editable()
    }

    @$el.html template(data)

    @renderLocationName()

    _.defer =>
      @$('.js-card-location-name-input').autosize(append: false)

    @
